// ESM-Konvertierung von lib/scripts/CLS_CFileLogging.js (Phase 4, Welle 2).
export class CFileLogging {
  constructor(logFile) {
    this.logFile = logFile || "";
    this.add(1, "Info", "*** Initialize ***", "", true);
  }

  add(loglevel, type, msg, details, blankLine) {
    try {
      if (typeof POS != "undefined" && typeof POS.EnvProperties.LOGLEVEL != "undefined" &&
          loglevel > POS.EnvProperties.LOGLEVEL)
        return;

      const now = new Date();
      const pad = (n) => (String(n).length == 1 ? "0" + n : String(n));
      const dateTime = pad(now.getDate()) + "." + pad(now.getMonth() + 1) + "." + now.getFullYear() +
        " " + pad(now.getHours()) + ":" + pad(now.getMinutes()) + ":" + pad(now.getSeconds());

      msg = (blankLine ? "\n" : "") + dateTime + " - " + type + ": " + msg;
      if (details && details != "")
        msg += "\n                      " + details;

      fs.fileName = this.logFile;
      fs.append(msg + "\n");
    } catch (e) {}
  }

  addTimestamp(msg) {
    this.add(new Date().getMilliseconds(), msg);
  }
}
